(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cannapopolis-card-buy-now"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('.cannapopolis-buy-now-form') || event.defaultPrevented) return;
    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    form.dataset.submitting = 'true';
    form.querySelector('[type="submit"]').disabled = true;
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.cannapopolis-buy-now-form[data-submitting]').forEach(function (form) {
      delete form.dataset.submitting;
      form.querySelector('[type="submit"]').disabled = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
